var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_609)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.664 34V32.688C16.664 31.6427 16.952 30.6933 17.528 29.84C18.104 28.9653 18.84 28.1547 19.736 27.408C20.632 26.6613 21.592 25.9467 22.616 25.264C23.64 24.56 24.6 23.8773 25.496 23.216C26.392 22.5547 27.128 21.872 27.704 21.168C28.28 20.4427 28.568 19.6747 28.568 18.864C28.568 17.6267 28.152 16.656 27.32 15.952C26.5093 15.248 25.336 14.896 23.8 14.896C22.392 14.896 21.24 15.216 20.344 15.856C19.4693 16.4747 18.9467 17.3813 18.776 18.576H16.376C16.504 17.36 16.8987 16.304 17.56 15.408C18.2427 14.4907 19.1173 13.7867 20.184 13.296C21.2507 12.8053 22.4347 12.56 23.736 12.56C25.272 12.56 26.5733 12.8373 27.64 13.392C28.728 13.9467 29.5493 14.6933 30.104 15.632C30.68 16.5707 30.968 17.6267 30.968 18.8C30.968 19.7813 30.7013 20.6987 30.168 21.552C29.6347 22.4053 28.9413 23.2053 28.088 23.952C27.2347 24.6987 26.328 25.4027 25.368 26.064C24.4293 26.7253 23.5227 27.376 22.648 28.016C21.7733 28.6347 21.048 29.2533 20.472 29.872C19.896 30.4693 19.576 31.0773 19.512 31.696H30.904V34H16.664Z",
    fill: "#1778E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.ebe6c04f.svg";
export { ForwardRef as ReactComponent };